
export default
`How do we live a [h]full life?[/h] Time is the
[h]greatest gift[/h] that we are given and yet,
as people, we have a tendency
to [h]fritter it[/h] away.

[m]Living a disciplined [h]life of creativity and[/h]
[h]productivity may[/h] provide great
achievements, but it can leave little time
for [h]pleasure and enjoyment[/h].[/m]

So how do we live a full life?

For a long time, I thought [h]that I was living[/h]
a full life - [h]but my path[/h] was to take a major
[h]diversion[/h].

This new direction was [h]painful[/h] and one
which for many years was confusing and
[h]frightening[/h]. But it was one with purpose –
one that was to guide me towards [h]higher
ground[/h].

[m]Fear provoked me to spend long periods
[h]searching for a cure[/h] – but the answer did
not lie in finding a cure… it lay in the [h]actual
journey.[/h]

No matter where [h]we are from,[/h]
we will all at some point be faced with
[h]struggle[/h] and [h]illness[/h]. We will need to look
deep inside ourselves to discover whether
we have [h]the courage[/h] to take that
all-important step forward.[/m]

[h]When we[/h] get knocked down, the
circumstance can often be [h]complicated[/h], but
the decision is [h]always simple[/h] – we either
give up or get up. The hand that I had been
dealt may have been [h]a painful one[/h], but I
committed to [h]keep[/h] getting [h]up[/h].

[m]I would use every [h]natural[/h] resource that I
could find in order to build [h]power in[/h] my
body and strength [h]in my mind.[/h] If my pain
would not relent, then neither would I...
I would take [h]‘0 days off’.[/h]

In committing to my cause every single day,
I would uncover one of [h]the most extraordinary[/h]
[h]realisations[/h] in life...
the act of [h]helping others.[/h]

When [h]fighting[/h] for yourself there will
always be a limit, but when fighting for
those who cannot fight [h]for themselves,[/h]
then the [h]possibilities[/h] are limitless.[/m]

[m]My pain was my struggle, [h]but my pain[/h] was
also my purpose... and it would be my
purpose that [h]could change[/h] the [h]lives[/h] of
others.

For so long [h]I was afraid[/h] that I was reaching
[h]the end…[/h] but I had not arrived at the end…
I had arrived at the [h]beginning.[/h][/m]

How do we live a full life?`
